import { createElementBlock as r, openBlock as o, createElementVNode as n, defineComponent as g, ref as d, watch as _, resolveComponent as i, renderSlot as c, createCommentVNode as l, createBlock as u, createTextVNode as C, toDisplayString as m, createVNode as h, withCtx as $, normalizeClass as b } from "vue";
import { _ as y } from "./_plugin-vue_export-helper-CHgC5LLL.js";
function S(e, t) {
  return o(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    n("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
    })
  ]);
}
function I(e, t) {
  return o(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    n("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m19.5 8.25-7.5 7.5-7.5-7.5"
    })
  ]);
}
function j(e, t) {
  return o(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    n("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 15.75 7.5-7.5 7.5 7.5"
    })
  ]);
}
const B = g({
  props: {
    title: String,
    description: String,
    open: Boolean
  },
  components: {
    ChevronUpIcon: j,
    ChevronDownIcon: I,
    ArrowPathIcon: S
  },
  emits: ["refresh"],
  slots: Object,
  setup(e, { emit: t }) {
    const a = d(!1), s = d(!0);
    return _(
      () => e.open,
      (p) => {
        a.value = p;
      },
      { immediate: !0 }
    ), {
      opened: a,
      mountSlot: s,
      refresh() {
        t("refresh"), s.value = !1, setTimeout(() => s.value = !0, 500);
      },
      refreshTitle: `Recharger le composant.

Utile si le changement de paramètre n'est pas dynamiquement pris en compte.
Utile pour tester le chargement du composant avec différente valeur`
    };
  }
}), D = { key: 1 }, T = { key: 2 }, U = {
  key: 0,
  class: "tt-col-span-full"
}, M = { class: "tt-border tt-rounded-md tt-p-2" }, N = { class: "tt-pl-4 tt-grid tt-grid-cols-2 tt-items-center tt-gap-2" };
function P(e, t, a, s, p, A) {
  const f = i("ChevronDownIcon"), v = i("ChevronUpIcon"), w = i("ArrowPathIcon"), k = i("t-button-icon");
  return o(), r("section", null, [
    n("h2", {
      onClick: t[0] || (t[0] = (E) => e.opened = !e.opened)
    }, [
      e.opened ? (o(), u(f, {
        key: 0,
        class: "tt-inline-block tt-w-5"
      })) : (o(), u(v, {
        key: 1,
        class: "tt-inline-block tt-w-5"
      })),
      C(" " + m(e.$props.title), 1)
    ]),
    e.$slots.description ? c(e.$slots, "description", { key: 0 }) : e.$props.description ? (o(), r("p", D, m(e.$props.description), 1)) : l("", !0),
    e.opened ? (o(), r("div", T, [
      e.$slots.parameters ? (o(), r("div", U, [
        n("div", M, [
          t[1] || (t[1] = n("div", { class: "tt-w-full tt-pb-4 tt-flex tt-justify-between" }, [
            n("span", null, "paramètres:")
          ], -1)),
          n("div", N, [
            c(e.$slots, "parameters", { refresh: e.refresh })
          ])
        ]),
        n("div", null, [
          h(k, {
            onClick: e.refresh,
            title: e.refreshTitle
          }, {
            default: $(() => [
              h(w, {
                class: b({ "tt-animate-spin": !e.mountSlot })
              }, null, 8, ["class"])
            ]),
            _: 1
          }, 8, ["onClick", "title"])
        ])
      ])) : l("", !0),
      e.mountSlot ? c(e.$slots, "default", {
        key: 1,
        open: e.opened
      }) : l("", !0)
    ])) : l("", !0)
  ]);
}
const V = /* @__PURE__ */ y(B, [["render", P]]), q = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: V
}, Symbol.toStringTag, { value: "Module" }));
export {
  V as D,
  I as a,
  j as b,
  q as c,
  S as r
};
//# sourceMappingURL=DemoSection-CBEo8w66.js.map
